import axios from 'axios'

export default {
  get: (eventId) => axios.get(`events/${eventId}/scheduled-sends`),
  estimate: (eventId, data) => axios.post(`events/${eventId}/scheduled-sends/estimate`, data),
  store: (eventId, data) => axios.post(`events/${eventId}/scheduled-sends/store`, data),
  show: (eventId, id) => axios.get(`events/${eventId}/scheduled-sends/${id}`),
  update: (eventId, id, data) => axios.post(`events/${eventId}/scheduled-sends/${id}/update`, data),
  cancel: (eventId, id) => axios.post(`events/${eventId}/scheduled-sends/${id}/cancel`),
  executeNow: (eventId, id) => axios.post(`events/${eventId}/scheduled-sends/${id}/execute-now`),
}
